export enum InvestmentStatus {
  CREATED = 'created',
  PENDING_ADMIN_APPROVAL = 'pending_admin_approval',
  APPROVED = 'approved',
  PENDING_PAYMENT = 'pending_payment',
  PENDING_REVIEW = 'pending_review',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  CANCELED = 'canceled',
}
